import { type FC } from 'react'
import { useTheme } from 'styled-components'

import { Breadcrumbs } from '@/components/shared/breadcrumbs/Breadcrumbs'
import { getBreadcrumbs } from '@/domain/breadcrumbs'
import { useGetSearchResultsData } from '@/hooks/srp/useGetSearchResultsData'
import { useLocale } from '@/hooks/useLocale'
import { Spacing } from '@/ui/atoms/spacing'

type SrpBreadcrumbProps = {
  pageH1Heading?: string
  isAutoBRPView?: boolean
}

export const SrpBreadcrumb: FC<SrpBreadcrumbProps> = ({ pageH1Heading, isAutoBRPView }) => {
  const { routeLocale } = useLocale()
  const { spacing } = useTheme()

  /**
   * It should get the cache saved on the server-side
   * This query access the same main call from the SRP requesting just the fragment needed for the breadcrumbs
   * */
  const { data: { searchQuery } = {}, loading } = useGetSearchResultsData({
    fetchPolicy: 'cache-only',
  })

  /** Breadcrumbs */
  const breadcrumbs = getBreadcrumbs({
    activeCategory: searchQuery?.category ?? undefined,
    keywords: searchQuery?.keywords,
    routeLocale,
  })

  if (isAutoBRPView && pageH1Heading) {
    breadcrumbs[breadcrumbs.length - 1].href = ''
    breadcrumbs[breadcrumbs.length - 1].label = pageH1Heading
  }

  return (
    <Spacing
      mBottom="0"
      medium={{ mBottom: spacing.defaultSmall }}
      data-testid="search-breadcrumbs"
    >
      <Breadcrumbs
        breadcrumbs={breadcrumbs}
        loading={loading}
        pageName="srp"
        shouldPreventLineWrap
        textAs={isAutoBRPView ? 'h1' : undefined}
      />
    </Spacing>
  )
}
